import React, { FC } from 'react';
import { Avatar } from '@mui/material';
import { getInitials } from '../../../../features/utils';

interface UserAvatarProps {
    avatarLink?: string;
    firstName?: string;
    lastName?: string;
}

const UserAvatar: FC<UserAvatarProps> = ({ avatarLink, firstName, lastName }) => {
    return (
        <Avatar
            sx={{
                width: 32,
                height: 32,
                bgcolor: 'common.white',
                color: 'common.black',
                border: '1px solid',
                borderColor: 'common.black',
                fontSize: '14px',
            }}
        >
            {avatarLink ? (
                <img src={avatarLink} alt={`${firstName} ${lastName}`} style={{ width: '100%', height: '100%' }} />
            ) : firstName && lastName ? (
                getInitials(firstName, lastName)
            ) : (
                ' '
            )}
        </Avatar>
    );
};

export default UserAvatar;
